import { render } from "./ResultsReturned.vue?vue&type=template&id=1a2fcb3c&ts=true"
import script from "./ResultsReturned.vue?vue&type=script&lang=ts"
export * from "./ResultsReturned.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__